import React from 'react';
import { HashLoader } from 'react-spinners';

const Loader2 = ({ 
  loading = true, 
  size = 50,
  useGradient = false 
}) => {
  const primaryColor = "#FDCC72";  // Peach/Orange
  const secondaryColor = "#4A90E2"; // Complementary Blue
  
  if (!loading) return null;
  
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        width: '100%',
        height: '100vh'
      }}
    >
      {useGradient ? (
        <div style={{ position: 'relative' }}>
          <HashLoader
            color={primaryColor}
            loading={loading}
            size={size}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: 0.5
          }}>
            <HashLoader
              color={secondaryColor}
              loading={loading}
              size={size}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        </div>
      ) : (
        <HashLoader
          color={primaryColor}
          loading={loading}
          size={size}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      )}
    </div>
  );
};

export default Loader2;
